var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuestion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.722,
    height: 18.723,
    viewBox: "0 0 18.722 18.723",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1703",
    "data-name": "Grupo 1703",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "question-circle",
    d: "M17.361,20.532a1.057,1.057,0,1,0,1.057,1.057A1.057,1.057,0,0,0,17.361,20.532Zm.29-.906h-.6a.453.453,0,0,1-.453-.453v-.014c0-2.655,2.923-2.4,2.923-4.054,0-.756-.67-1.518-2.168-1.518a2.5,2.5,0,0,0-2.235,1.083.452.452,0,0,1-.613.09l-.5-.345a.452.452,0,0,1-.1-.648,3.961,3.961,0,0,1,3.444-1.689c1.975,0,3.678,1.123,3.678,3.028,0,2.545-2.923,2.41-2.923,4.054v.014A.453.453,0,0,1,17.651,19.626Zm-.29-10.418a8.153,8.153,0,1,1-8.153,8.153,8.154,8.154,0,0,1,8.153-8.153m0-1.208a9.361,9.361,0,1,0,9.361,9.361A9.363,9.363,0,0,0,17.361,8Z",
    transform: "translate(-8 -8)",
    fill: "#5e6466"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestion);
export default __webpack_public_path__ + "static/media/icon-question.1f03a70516c8b4c1987b9fb1ba90f6a8.svg";
export { ForwardRef as ReactComponent };